import { UserItem } from "../models/user";

const COOKIE_NAME = "flangoo_auth";
const COOKIE_PATH = "/";
const COOKIE_EXPIRY_DAYS = 30;

// Get the current domain
const getCookieDomain = (): string => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return ""; // Empty domain for localhost
  }
  return process.env.REACT_APP_DOMAIN || ""; // Use environment variable or empty string
};

export const setAuthCookie = (user: UserItem): void => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);

  const cookieValue = encodeURIComponent(JSON.stringify(user));
  const domain = getCookieDomain();
  const domainPart = domain ? `domain=${domain};` : "";

  document.cookie = `${COOKIE_NAME}=${cookieValue}; expires=${expiryDate.toUTCString()}; ${domainPart} path=${COOKIE_PATH}; SameSite=Lax; Secure`;
};

// Function overloads
export function getAuthCookie(force: true): UserItem;
export function getAuthCookie(force?: false): UserItem | null;
export function getAuthCookie(force: boolean = false): UserItem | null {
  const cookies = document.cookie.split(";");
  const authCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${COOKIE_NAME}=`)
  );

  if (!authCookie) {
    if (force) {
      // If force is true and no user is detected, trigger logout
      removeAuthCookie();
      localStorage.clear();
      localStorage.setItem(
        "logoutType",
        "Session expired. Please log in again."
      );
      setTimeout(() => {
        window.location.href = "/signin";
      }, 500);
      throw new Error("No user session found"); // This ensures TypeScript knows the function won't return null when force is true
    }
    return null;
  }

  try {
    const cookieValue = decodeURIComponent(authCookie.split("=")[1]);
    return JSON.parse(cookieValue);
  } catch (error) {
    console.error("Error parsing auth cookie:", error);
    if (force) {
      // If force is true and cookie parsing fails, trigger logout
      removeAuthCookie();

      throw new Error("Invalid user session"); // This ensures TypeScript knows the function won't return null when force is true
    }
    return null;
  }
}

export const removeAuthCookie = (): void => {
  const domain = getCookieDomain();
  const domainPart = domain ? `domain=${domain};` : "";

  localStorage.clear();
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${domainPart} path=${COOKIE_PATH}; SameSite=Lax; Secure`;
  setTimeout(() => {
    window.location.href = "/";
  }, 500);
};
